const CANVAS_SNAPSHOT_KEY = "canvasSnapshot";

/**
 * Persist canvas preview (often a large data URL) for MyCanvas.
 * Tries localStorage, then sessionStorage; ignores quota errors so navigation can
 * still pass the snapshot via React Router state (e.g. currentSnapshot).
 */
export function safeSetCanvasSnapshot(snapshot) {
  if (!snapshot || typeof snapshot !== "string") return;
  try {
    localStorage.setItem(CANVAS_SNAPSHOT_KEY, snapshot);
    try {
      sessionStorage.removeItem(CANVAS_SNAPSHOT_KEY);
    } catch {
      /* ignore */
    }
    return;
  } catch {
    /* QuotaExceededError or other — try separate sessionStorage quota */
  }
  try {
    sessionStorage.setItem(CANVAS_SNAPSHOT_KEY, snapshot);
  } catch {
    /* Rely on location.state.currentSnapshot */
  }
}

export function getCanvasSnapshotFromStorage() {
  return (
    localStorage.getItem(CANVAS_SNAPSHOT_KEY) ||
    sessionStorage.getItem(CANVAS_SNAPSHOT_KEY) ||
    null
  );
}

export function clearCanvasSnapshotFromStorage() {
  try {
    localStorage.removeItem(CANVAS_SNAPSHOT_KEY);
  } catch {
    /* ignore */
  }
  try {
    sessionStorage.removeItem(CANVAS_SNAPSHOT_KEY);
  } catch {
    /* ignore */
  }
}
